import { SerialNumberElasticDto } from "../models"
import { PaginatedSearchPayload } from "../../../search/SearchPayload"

export const SERIAL_NUMBER_ACTION_TYPES = {
    FETCH_SERIAL_NUMBER_LISTING: "FETCH_SERIAL_NUMBER_LISTING" as const,
    CLEAR_SERIAL_NUMBER_LISTING: "CLEAR_SERIAL_NUMBER_LISTING" as const,
    FETCH_SERIAL_NUMBER_LISTING_SUCCESS: "FETCH_SERIAL_NUMBER_LISTING_SUCCESS" as const,
    FETCH_SERIAL_NUMBER_LISTING_ERROR: "FETCH_SERIAL_NUMBER_LISTING_ERROR" as const,
}

export type FetchSerialNumberListingParams =
    Partial<PaginatedSearchPayload>
    & Pick<SerialNumberElasticDto, "productId">

export type Actions =
|  { type: typeof SERIAL_NUMBER_ACTION_TYPES.FETCH_SERIAL_NUMBER_LISTING_SUCCESS, payload: Array<SerialNumberElasticDto>}
|  { type: typeof SERIAL_NUMBER_ACTION_TYPES.FETCH_SERIAL_NUMBER_LISTING_ERROR, payload: string}
|  { type: typeof SERIAL_NUMBER_ACTION_TYPES.FETCH_SERIAL_NUMBER_LISTING, payload: FetchSerialNumberListingParams}
|  { type: typeof SERIAL_NUMBER_ACTION_TYPES.CLEAR_SERIAL_NUMBER_LISTING}





// WEBPACK FOOTER //
// ./src/state/listing/serial-numbers/actions/types.ts